import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/organize/layer.organize.categoryOrder.mutation.gql"
import type {
  LayerCategoryOrderUpdateMutation,
  LayerCategoryOrderUpdateMutationVariables,
} from "@/v2-backoffice-client/layer/organize/__types__/layer.organize.categoryOrder.mutation"

type Options = MutationHookOptions<
  LayerCategoryOrderUpdateMutation,
  LayerCategoryOrderUpdateMutationVariables
>

export function useLayerCategoryOrderUpdateMutation(options?: Options) {
  return useMutation<
    LayerCategoryOrderUpdateMutation,
    LayerCategoryOrderUpdateMutationVariables
  >(mutation, options)
}
